import { MessageType } from './message'

export enum MediaStatus {
  Pending,
  Ready,
  Failed,
}

export enum MediaType {
  Video,
  Image,
  GIF,
  Audio,
}

export interface Media {
  id: number
  status: MediaStatus
  type: MediaType
  src?: string
  thumbnail?: string
  width?: number
  height?: number
}

export const convertMediaTypeToMessageType = (type: MediaType): MessageType => {
  return type === MediaType.Image ? MessageType.Image : MessageType.Video
}
